import React from 'react';
import './style.css';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';

const NextQuestionButton = props => {
  const { t } = props;
  let text = t('NEXT QUESTION');
  if (props.text) {
    text = props.text;
  }
  let newProps = {};
  if (props.disabled) {
    newProps.disabled = true;
  }
  if (props.autoFocus) {
    newProps.autoFocus = true;
  }
  if (props.onClick) {
    newProps.onClick = props.onClick;
  }

  return (
    <div className="App-answer-button">
      <Link to={props.to}>
        <button className="btn btn-primary btn-round btn-block" {...newProps}>
          {text}
        </button>
      </Link>
    </div>
  );
};

export default translate('translations')(NextQuestionButton);



// WEBPACK FOOTER //
// ./src/preference/components/NextQuestionButton/index.js